import { type ReactElement, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAppStore } from '../hooks/store/useAppStore';
import { useLaunchOnly } from './useAisCapabilities';

const workflowOpen = () => {
  const { aisLaunchIdForCreate, requestIdForUpdate, requestIdForReorder } = useAppStore.getState();
  return !!aisLaunchIdForCreate || !!requestIdForUpdate || !!requestIdForReorder;
};

// A launch-only session opens the request workflow only for the AIS's Anforderung or one that exists already
export const LaunchOnlyRoute = ({ children, workflow = false }: { children: ReactElement; workflow?: boolean }) => {
  const launchOnly = useLaunchOnly();
  const { pathname } = useLocation();
  // decided per route entered: clearing the store on the way out must not redirect the pending navigation
  const [entered, setEntered] = useState(() => ({ pathname, open: workflowOpen() }));
  const current = entered.pathname === pathname ? entered : { pathname, open: workflowOpen() };
  if (current !== entered) {
    setEntered(current);
  }
  return launchOnly && !(workflow && current.open) ? <Navigate replace to="/offene-anforderungen" /> : children;
};
